export default [
  {
    index: 1,
    section: "institute",
    subSection: [
      "news",
      "staff",
      "experimentalbase",
      "technicalequipment",
      "youngscientists",
      "anticorruption",
      "govpurchases",
    ],
  },

  {
    index: 2,
    section: "performance",
    subSection: ["currentprojects", "publications", "seminars", "patents"],
  },

  {
    index: 3,
    section: "services",
    subSection: [
      "geophysicalforecast",
      "geomagneticdimensions",
      "aerospacemonitoring",
      "geoinformsystemdevelopment",
    ],
  },

  {
    index: 4,
    section: "labs",
    subSection: [
      "diagnosticlab",
      "nonstationarylab",
      "geomagneticlab",
      "reliabilitylab",
      "geodynamiclab",
      "complexlab",
      "cartographylab",
    ],
  },
];
